import React from "react";
import { CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import * as styles from "../../styles/pages/SuccessPage.Styles";

const SuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.successPageContainer}>
      <div className={styles.successCard}>
        {/* Success Icon */}
        <div className={styles.successIcon}>
          <CheckCircle className={styles.iconStyle} />
        </div>

        {/* Success Message */}
        <h2 className={styles.successTitle}>Password Reset</h2>
        <p className={styles.successText}>
          Your password has been successfully reset.
          <br />
          Click below to log in.
        </p>

        {/* Buttons */}
        <button
          className={styles.continueButton}
          onClick={() => navigate("/signin")}
        >
          Continue
        </button>
        <button
          className={styles.backButton}
          onClick={() => navigate("/signin")}
        >
          ← Back to log in
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;